import React, { useId } from "react";
import {
  TableContainer,
  TableWrapper,
  Table,
  TableHeader,
  TableHeaderCell,
  TableBody,
  TableRow,
  TableCell,
  PaginationWrapper,
  PaginationButton,
  CellSeparator
} from "./CustomTableStyles";
import useEmpresa from "../../hooks/useEmpresa";
import CheckRender from "../Common/CheckRender";
import Colors from "../../themes/Colors";

const CustomTable = ({
  columns,
  dataSource,
  pageSize,
  headerColor,
  textHeaderColor,
  paginationColor,
  showPagination,
  hideHeader,
  cellColor,
  width,
  maxWidth
}) => {
  const [currentPage, setCurrentPage] = React.useState(1);

  const empresa = useEmpresa();

  const id = useId();

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalItems = dataSource.length;
  const totalPages = Math.ceil(totalItems / pageSize);
  const indexOfLastItem = currentPage * pageSize;
  const indexOfFirstItem = indexOfLastItem - pageSize;
  const currentItems = dataSource.slice(indexOfFirstItem, indexOfLastItem);

  const renderTableHeaders = () => (
    <TableHeader
      headerColor={headerColor || Colors.transparent}
      textColor={textHeaderColor || Colors.white}
      font={empresa?.LETRA_PRINCIPAL}
      key={id}
    >
      <tr>
        {columns.map((column, index) => (
          <React.Fragment key={index}>
            <TableHeaderCell
              key={column.key}
              font={empresa?.LETRA_PRINCIPAL}
              cellColor={cellColor || empresa?.COLOR_PRINCIPAL}
            >
              {column.title}
            </TableHeaderCell>
            <CellSeparator width={"3px"} />
          </React.Fragment>
        ))}
      </tr>
    </TableHeader>
  );

  const renderTableRows = () =>
    currentItems.map((item, index) => (
      <TableRow key={index}>
        {columns.map((column, columnIndex) => (
          <React.Fragment key={`${column.key}-${index}`}>
            <TableCell key={column.key} font={empresa?.LETRA_PRINCIPAL}>
              {column.render
                ? column.render(item[column.dataIndex], item, index)
                : item[column.dataIndex]}
            </TableCell>
            <CellSeparator width={"3px"} />
          </React.Fragment>
        ))}
      </TableRow>
    ));

  const renderPagination = () => (
    <PaginationWrapper font={empresa?.LETRA_PRINCIPAL}>
      {Array.from(Array(totalPages).keys()).map((pageNumber) => (
        <PaginationButton
          key={pageNumber}
          active={pageNumber + 1 === currentPage}
          onClick={() => handlePageChange(pageNumber + 1)}
          paginationColor={paginationColor || empresa?.COLOR_PRINCIPAL}
          font={empresa?.LETRA_PRINCIPAL}
        >
          {pageNumber + 1}
        </PaginationButton>
      ))}
    </PaginationWrapper>
  );

  return (
    <TableContainer font={empresa?.LETRA_PRINCIPAL}>
      <TableWrapper font={empresa?.LETRA_PRINCIPAL} width={width} maxWidth={maxWidth}>
        <Table font={empresa?.LETRA_PRINCIPAL}>
          <CheckRender allowed={!hideHeader}>
            {renderTableHeaders()}
          </CheckRender>
          <TableBody>{renderTableRows()}</TableBody>
        </Table>
      </TableWrapper>

      <CheckRender allowed={showPagination}>{renderPagination()}</CheckRender>
    </TableContainer>
  );
};

export default CustomTable;